import { L } from '@lib';
import React from 'react';
import { SoftTag } from './SoftTag';

interface IProps {
  /** The customer's app account; none = not on the app. */
  userId?: number | null;
  style?: React.CSSProperties;
}

/** Whether a customer is on the app: green when they are, the danger red when they are not. */
export const AppUserTag: React.FC<IProps> = ({ userId, style }) => (
  <SoftTag group={userId ? 'green' : 'danger'} style={style}>
    {userId ? L('App user') : L('Not on app')}
  </SoftTag>
);
